export var STATUS_DRAFT_TEXT = 'Sign this note for payment in a future invoice';
// Format expected to get from the api
export var EHR_DATE_FORMAT = 'yyyy-MM-dd';
export var MONTH_DAY_YEAR_FORMAT = 'MMM d, yyyy';
export var SHORT_MONTH_DAY_FORMAT = 'MMM d';
export var LONG_MONTH_DAY_YEAR_FORMAT = 'EEE MMM d, t ZZZZ';
export var LONG_MONTH_DAY_TIME_FORMAT = 'EEE MMM d, yyyy';
export var StatusTextEnum;
(function (StatusTextEnum) {
    StatusTextEnum["draft"] = "Invoice open.";
    StatusTextEnum["finalized"] = "Invoice closed";
    StatusTextEnum["processed"] = "Payment processing";
    StatusTextEnum["settled"] = "Payment posted";
})(StatusTextEnum || (StatusTextEnum = {}));
export var StatusTextArticleEnum;
(function (StatusTextArticleEnum) {
    StatusTextArticleEnum["draft"] = "Last updated on";
    StatusTextArticleEnum["finalized"] = "on";
    StatusTextArticleEnum["processed"] = "as of";
    StatusTextArticleEnum["settled"] = "on";
})(StatusTextArticleEnum || (StatusTextArticleEnum = {}));
export var ApptStatusTextEnum;
(function (ApptStatusTextEnum) {
    ApptStatusTextEnum["Completed"] = "Client attended";
    ApptStatusTextEnum["Not Attended"] = "Client did not attend";
    ApptStatusTextEnum["Late Cancel"] = "Client canceled late";
})(ApptStatusTextEnum || (ApptStatusTextEnum = {}));
